import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon, MapPinIcon, CalendarIcon, CameraIcon, UploadIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const JURISDICTION_STATES = ['VA', 'MD', 'WV'];
export function QuotePage() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    zip: '',
    state: '',
    availability: ''
  });
  const handleNext = () => setStep(s => s + 1);
  const isWithinJurisdiction = JURISDICTION_STATES.includes(formData.state.toUpperCase());
  return <Layout data-id="element-557">
      <div className="min-h-[80vh] bg-alabaster flex items-center justify-center py-24 px-6" data-id="element-558">
        <div className="w-full max-w-2xl bg-white border-3 border-charcoal p-12 shadow-[16px_16px_0px_0px_rgba(26,26,26,1)]" data-id="element-559">
          <div className="flex justify-between items-center mb-12" data-id="element-560">
            <h1 className="text-3xl font-bold uppercase tracking-tighter" data-id="element-561">
              Get Your Quote
            </h1>
            <div className="flex gap-2" data-id="element-562">
              {[1, 2, 3].map(i => <div key={i} className={`w-3 h-3 border-2 border-charcoal ${step >= i ? 'bg-espresso' : 'bg-transparent'}`} data-id="element-563" />)}
            </div>
          </div>

          <AnimatePresence mode="wait" data-id="element-564">
            {step === 1 && <motion.div key="step1" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-6" data-id="element-565">
                <h2 className="text-xl font-bold font-serif italic" data-id="element-566">
                  Tell us about yourself
                </h2>
                <div className="space-y-4" data-id="element-567">
                  <input type="text" placeholder="Full Name" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} data-id="element-568" />
                  <input type="email" placeholder="Email Address" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-569" />
                  <input type="tel" placeholder="Phone Number" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} data-id="element-570" />
                </div>
                <button onClick={handleNext} className="w-full bg-charcoal text-alabaster py-4 font-bold uppercase tracking-widest flex items-center justify-center gap-2 hover:bg-espresso transition-colors" data-id="element-571">
                  Next Step <ArrowRightIcon className="w-4 h-4" data-id="element-572" />
                </button>
              </motion.div>}

            {step === 2 && <motion.div key="step2" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-6" data-id="element-573">
                <h2 className="text-xl font-bold font-serif italic" data-id="element-574">
                  Where is your kitchen located?
                </h2>
                <div className="space-y-4" data-id="element-575">
                  <input type="text" placeholder="Zip Code" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.zip} onChange={e => setFormData({
                ...formData,
                zip: e.target.value
              })} data-id="element-576" />
                  <select className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none bg-white" value={formData.state} onChange={e => setFormData({
                ...formData,
                state: e.target.value
              })} data-id="element-577">
                    <option value="" data-id="element-578">Select State</option>
                    <option value="MD" data-id="element-579">Maryland</option>
                    <option value="VA" data-id="element-580">Virginia</option>
                    <option value="WV" data-id="element-581">West Virginia</option>
                    <option value="DC" data-id="element-582">District of Columbia</option>
                    <option value="PA" data-id="element-583">Pennsylvania</option>
                    <option value="OTHER" data-id="element-584">Other</option>
                  </select>
                </div>
                <button onClick={handleNext} className="w-full bg-charcoal text-alabaster py-4 font-bold uppercase tracking-widest flex items-center justify-center gap-2 hover:bg-espresso transition-colors" data-id="element-585">
                  Check Availability <ArrowRightIcon className="w-4 h-4" data-id="element-586" />
                </button>
              </motion.div>}

            {step === 3 && isWithinJurisdiction && <motion.div key="step3-in" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="space-y-6" data-id="element-587">
                <div className="bg-espresso/10 p-6 border-l-4 border-espresso" data-id="element-588">
                  <h2 className="text-xl font-bold text-espresso mb-2" data-id="element-589">
                    Great News!
                  </h2>
                  <p className="text-sm text-charcoal/70" data-id="element-590">
                    A technician is available in your area. We'd like to send
                    someone out for a free survey.
                  </p>
                </div>
                <div className="space-y-4" data-id="element-591">
                  <label className="block text-sm font-bold uppercase tracking-widest" data-id="element-592">
                    When are you available for a visit?
                  </label>
                  <textarea placeholder="e.g. Monday afternoons or Tuesday mornings..." className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none h-32" value={formData.availability} onChange={e => setFormData({
                ...formData,
                availability: e.target.value
              })} data-id="element-593" />
                </div>
                <button className="w-full bg-charcoal text-alabaster py-4 font-bold uppercase tracking-widest hover:bg-espresso transition-colors" data-id="element-594">
                  Submit Request
                </button>
              </motion.div>}

            {step === 3 && !isWithinJurisdiction && <motion.div key="step3-out" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="space-y-6" data-id="element-595">
                <div className="bg-charcoal/5 p-6 border-l-4 border-charcoal" data-id="element-596">
                  <h2 className="text-xl font-bold mb-2" data-id="element-597">
                    Remote Quote Available
                  </h2>
                  <p className="text-sm text-charcoal/70" data-id="element-598">
                    We don't have technicians in your area yet, but we can
                    provide a custom quote via photos.
                  </p>
                </div>
                <div className="border-3 border-dashed border-charcoal/20 p-12 flex flex-col items-center justify-center gap-4 bg-alabaster hover:border-espresso transition-colors cursor-pointer group" data-id="element-599">
                  <UploadIcon className="w-10 h-10 text-charcoal/20 group-hover:text-espresso transition-colors" data-id="element-600" />
                  <p className="text-sm font-bold uppercase tracking-widest text-charcoal/40 group-hover:text-charcoal" data-id="element-601">
                    Upload 3 Kitchen Photos
                  </p>
                </div>
                <button className="w-full bg-espresso text-alabaster py-4 font-bold uppercase tracking-widest hover:bg-charcoal transition-colors" data-id="element-602">
                  Get Remote Quote
                </button>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </Layout>;
}